
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 34 34"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd"}},[_c('path',{attrs:{"d":"M29.467 8.612l-7.359-7.358A.86.86 0 0021.497 1H5.144a.865.865 0 00-.865.865v30.27c0 .478.388.865.865.865h23.712a.865.865 0 00.865-.865V9.223c0-.23-.092-.45-.254-.611zm-1.755.69h-6.325V2.978l6.325 6.324zM6.009 31.27V2.73h13.648v7.438c0 .478.387.865.865.865h7.469V31.27H6.009z"}}),_c('path',{attrs:{"d":"M9.75 10.6h6.262a.432.432 0 000-.864H9.75a.432.432 0 000 .864zm0 3.901h14.5a.432.432 0 000-.864H9.75a.432.432 0 000 .864zm3.491 10.067l-.144.911-.186-.817-1.305-4.72h-.753l-1.337 4.72-.191.803-.13-.892-1.068-4.631h-.893l1.636 6.763h.813l1.444-4.929.107-.515.107.515 1.394 4.929h.813l1.64-6.763h-.897m3.614-.001l-2.583 6.764h.92l.636-1.77h2.834l.645 1.77h.916l-2.588-6.764h-.78zm-.757 4.265l1.148-3.163 1.152 3.163h-2.3zm6.87 1.315l-1.923-5.579h-.971l2.504 6.763h.79l2.508-6.763h-.976"}})])])
          )
        }
      }
    